import { fetchConsultants, fetchConsultant } from 'actions/consultants';

const consultants = () => {
  const initialState = {
    consultants: null,
    selectedConsultant: null,
  };

  return (state = initialState, { type, response }) => {
    switch (type) {
      case fetchConsultants.requestTypes.SUCCESS:
        return {
          ...state,
          consultants: response,
        };
      case fetchConsultant.requestTypes.SUCCESS:
        return {
          ...state,
          selectedConsultant: response,
        };
      default:
        return state;
    }
  };
};

export default consultants();
